import { render, staticRenderFns } from "./ParcelsHead.vue?vue&type=template&id=598b3aac&scoped=true"
import script from "./ParcelsHead.vue?vue&type=script&lang=js"
export * from "./ParcelsHead.vue?vue&type=script&lang=js"
import style0 from "./ParcelsHead.vue?vue&type=style&index=0&id=598b3aac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598b3aac",
  null
  
)

export default component.exports